import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import { ProductColorsState } from '../types'
import featureStateSelector from './featureStateSelector'

export const isNeedToFetchListSelector = createSelector<ReduxState, ProductColorsState, boolean>(
  featureStateSelector,
  state => {
    const { pages, currentPage } = state.pagination
    return !pages[currentPage]
  }
)
